import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { isNativeAppUA } from 'dpl/shared/utils';

import StripeChargeModalPaymentSummaryLineItemV2 from './StripeChargeModalPaymentSummaryLineItemV2';

const IS_NATIVE_UA = isNativeAppUA();

function MobileTooltipDisplay({ description, tooltipDescription }) {
  return (
    <div className="MobileTooltipDisplay">
      <div className="mb6 bb b--lightest-gray">
        <h5 className="f3 f4-md fw-medium pb3 tc pt1">{description}</h5>
      </div>
      <p className="font-16 ph6">{tooltipDescription}</p>
    </div>
  );
}

function DesktopModalDisplay({ description, tooltipDescription }) {
  return (
    <div className="DesktopModalDisplay pv5">
      <div className="container">
        <div className="row pb3 mb6 bb b--lightest-gray">
          <h5 className="f4 fw-medium col tc">{description}</h5>
        </div>
        <div className="row pb6 ph8">
          <p className="font-16 tc">{tooltipDescription}</p>
        </div>
      </div>
    </div>
  );
}

export default function StripeChargeModalPaymentProcessingLineItem({
  amountInDollars,
  discountedPriceInDollars,
  paymentMethod,
  ...rest
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const showDiscount =
    paymentMethod && discountedPriceInDollars !== amountInDollars;

  function handleNativeTooltipClick() {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'OpenInBrowser',
        value: window.location.href
      })
    );
  }

  const tooltipDescription = IS_NATIVE_UA ? (
    <span>
      100% of this fee goes to cover costs for payment processing. You can pay
      by bank transfer (ACH) for a full {discountedPriceInDollars} discount{' '}
      <button
        type="button"
        className="primary"
        onClick={handleNativeTooltipClick}
      >
        using our website
      </button>
      .
    </span>
  ) : (
    rest.tooltipDescription
  );

  return (
    <StripeChargeModalPaymentSummaryLineItemV2
      iconProps={{
        name: 'fetch-info'
      }}
      amountInDollars={amountInDollars}
      {...rest}
      discountedPriceInDollars={showDiscount ? discountedPriceInDollars : null}
      tooltipProps={{
        minWidth: '250px',
        title: (
          <MobileTooltipDisplay
            description={rest.description}
            tooltipDescription={tooltipDescription}
          />
        ),
        isVisible: isTooltipOpen,
        onClick: () => setIsTooltipOpen(true),
        onCloseTooltipClick: () => setIsTooltipOpen(false)
      }}
      modalProps={{
        content: (
          <DesktopModalDisplay
            description={rest.description}
            tooltipDescription={tooltipDescription}
          />
        )
      }}
    />
  );
}

MobileTooltipDisplay.propTypes = {
  description: PropTypes.string.isRequired,
  tooltipDescription: PropTypes.string.isRequired
};

DesktopModalDisplay.propTypes = {
  description: PropTypes.string.isRequired,
  tooltipDescription: PropTypes.string.isRequired
};

StripeChargeModalPaymentProcessingLineItem.propTypes = {
  amountInDollars: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  paymentMethod: PropTypes.string,
  longDescription: PropTypes.string,
  discountedPriceInDollars: PropTypes.string,
  tooltipDescription: PropTypes.string
};

StripeChargeModalPaymentProcessingLineItem.defaultProps = {
  longDescription: null,
  discountedPriceInDollars: null,
  tooltipDescription: null,
  paymentMethod: null
};

MobileTooltipDisplay.propTypes = {
  description: PropTypes.string.isRequired,
  tooltipDescription: PropTypes.string
};

MobileTooltipDisplay.defaultProps = {
  tooltipDescription: null
};
